(() => {
  const initPartnerMarquee = (marquee) => {
    if (!marquee || marquee.dataset.partnerReady === 'true') return;

    const track = marquee.querySelector('[data-partner-track]');
    const group = marquee.querySelector('[data-partner-group]');
    if (!track || !group) return;

    const clone = group.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    clone.removeAttribute('role');
    clone.querySelectorAll('[role]').forEach((item) => item.removeAttribute('role'));
    clone.querySelectorAll('img').forEach((image) => image.setAttribute('alt', ''));
    track.appendChild(clone);

    marquee.dataset.partnerReady = 'true';
    marquee.classList.add('is-ready');
  };

  const initAll = (root = document) => {
    root.querySelectorAll('[data-partner-marquee]').forEach(initPartnerMarquee);
  };

  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
